import React, { useEffect, useRef } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Micro from '@amcharts/amcharts5/themes/Micro';

export default function Sparklines(props) {
  const chartRef = useRef(null);

  useEffect(() => {
    // Ensure the ref has been attached
    if (!chartRef.current) return;


    // Create root element
    const data = props?.runTrends;

    am5.addLicense("AM5C137048159");
    let root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Micro.new(root)]);

    let chart = am5xy.XYChart.new(root, {
      focusable: true,
      panX: false,
      panY: false,
      wheelX: "none",
      wheelY: "none",
      pinchZoomX: false
    });

    root.container.children.push(chart);
    chart.plotContainer.set("wheelable", false);
    chart.zoomOutButton.set("forceHidden", true);

    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {

        renderer: am5xy.AxisRendererX.new(root, {
          inversed: true,
          minGridDistance: 1
        })
      })
    );
    xAxis.get("renderer").grid.template.setAll({ strokeOpacity: 0 });
    xAxis.get("renderer").labels.template.set('visible', false);

    let yRenderer = am5xy.AxisRendererY.new(root, {

    })
    yRenderer.labels.template.set('visible', false);
    yRenderer.grid.template.set("strokeOpacity", 0);
    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0,
        renderer: yRenderer
      })
    );

    const series = chart.series.push(
      am5xy.LineSeries.new(root, {
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: props?.column,
        //categoryXField: "run",
        valueXField: "run",
        baseAxis: xAxis,
        name: props?.column === "projectedGas" ? "Projected" : props?.column,
        stroke: am5.color("#12B76A")
      })
    );

    series.data.setAll(data);
    series.appear(10, 0);

    if (props?.column === "projectedGas") {
      // Add target series
      const targetSeries = chart.series.push(
        am5xy.LineSeries.new(root, {
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "target",
          valueXField: "run",
          baseAxis: xAxis,
          name: "Target",
          stroke: am5.color("#828A99")

        })
      );

      targetSeries.data.setAll(data);
      targetSeries.appear(10, 0);
    }

    chart.set("cursor", am5xy.XYCursor.new(root, {
      xAxis: xAxis,
      yAxis: yAxis,

    }));

    xAxis.data.setAll(data);

    chart.appear(10, 10);


    var tooltip = am5.Tooltip.new(root, {
      dy: 10,

    });

    chart.plotContainer.set("tooltipPosition", "pointer");
    chart.plotContainer.set("tooltipText", "a");
    chart.plotContainer.set("tooltip", tooltip);

    tooltip.label.adapters.add("text", function (text, target) {
      text = ""
      var i = 0;

      chart.series.each(function (series) {
        var tooltipDataItem = series.get("tooltipDataItem");
        if (tooltipDataItem) {
          if (i !== 0) {
            text += "\n";
          }
          if (props?.column === "projectedGas")
            text += '[fontSize:11px;]' + series.get("name") + ': ' + (tooltipDataItem.get("valueY") == null ? "" : tooltipDataItem.get("valueY").toFixed());
          else
            text += '[fontSize:11px]' + (tooltipDataItem.get("valueY") == null ? "" : tooltipDataItem.get("valueY").toFixed());
        }
        i++;
      });
      return text;
    });
    tooltip.get("background").setAll({
      fill: am5.color("#001023"),  // Background color
      stroke: am5.color("#001023"), // Border color,    
      fillOpacity: 0.5
    });

    return () => {
      root.dispose();
      chart.dispose();
    };

  }, [props?.runTrends, props?.column, props?.assetId, props?.slowArrival, props?.fastArrival]); // Added all relevant dependencies to avoid stale closure issues

  return <div ref={chartRef} style={{ width: '100%', height: '90%' }}></div>;
}
